export class ocppConnector {

  // minimum time in terms of Minutes for a charge point to be in Not Connected status
  static readonly durationForNotConnected: number = 90*24*60;

  ocppConnectorId: string;
  ocppStatus: string;
  ocppStatusTime: any;
  ocppErrorCode: any;
  socUnit: any;
  socValue: any
  ocppIcon: any;
  ocppIconColor: any;

  constructor(data?) {
    if (!data) {
      return;
    }
    this.ocppConnectorId = data.ocppConnectorId;
    this.ocppStatus = data.ocppStatus ? data.ocppStatus : 'No Status';
    this.ocppStatusTime = data.ocppStatusTime;
    this.ocppErrorCode = data.ocppErrorCode ? data.ocppErrorCode : '';
    this.socUnit = data.socUnit ? data.socUnit : '';
    this.socValue = data.socValue ? data.socValue : '';
    this.setOcppIcon(data.ocppStatus);
  }

  setOcppIcon(ocppStatus) {
    switch (ocppStatus) {
      case "Available":
      case "Preparing":
        this.ocppIcon = 'checkmark-circle-2';
        this.ocppIconColor = "#0AC032";
        break;
      case "Charging":
      case "Finishing":
        this.ocppIcon = 'flash';
        this.ocppIconColor = "#46A3FF";
        break;
      case "Faulted":
        this.ocppIcon = 'alert-triangle';
        this.ocppIconColor = "#FF0026";
        break;
      case "Reserved":
        this.ocppIcon = 'checkmark-circle-2';
        this.ocppIconColor = "#FA00FF";
        break;
      case "SuspendedEVSE":
      case "SuspendedEV":
        this.ocppIcon = 'flash';
        this.ocppIconColor = "#E3941E";
        break;
      case "Unavailable":
      case "Not Connected":
      case "No Status":
      default:
        this.ocppIcon = 'close-circle';
        this.ocppIconColor = "#636E72";
        break;
    }
  }
}

